// @flow
import * as React from 'react';
import DollarInput from 'components/DollarInput';
import Field from './Field';

const DollarInputField = ({
  name,
  label,
  description,
  mapError,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  mapError?: string => React.Node
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    mapError={mapError}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <DollarInput
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={e => {
          updateValue(e.target.value);
        }}
        {...props}
      />
    )}
  />
);

export default DollarInputField;
